import React, {Component} from 'react'
import AppConfig from "../AppConfig";

export default class Zgody extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return <div>
            {this.props.war1 ? <div className="inputZgodyDiv">
                <input type="checkbox" checked={this.props.newsletter}
                       onChange={() => this.props.setNewsletter()}/> Wyrażam zgodę na otrzymywanie drogą elektroniczną
                na wskazany przeze mnie adres e – mail informacji o
                nowościach, promocjach, produktach
                i usługach pochodzących od MARCEL Sp. z o.o. Sp. k.
            </div> : null}
            {this.props.war2 ? <div className="inputZgodyDiv">
                <input type="checkbox" checked={this.props.warunki}
                       onChange={() => this.props.setWarunki()}/> Oświadczam, że zapoznałem się z <a
                href={AppConfig.HOST_API() + '' + 'client/api/plik/link/warunki-przewozu'} target={'_blank'}>warunkami
                przewozu</a> oraz <a href={AppConfig.HOST_API() + '' + 'client/api/plik/link/polityka-prywatnosci'}
                                     target={'_blank'}>polityką prywatności</a> w zakresie przetwarzania moich danych
                osobowych.</div> : null}
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/shared/Zgody.js